export const AGENCY_SHIFT_HISTORIES_FETCH_BEGIN = 'syftacp/AGENCY_SHIFT_HISTORIES_FETCH_BEGIN'
export const AGENCY_SHIFT_HISTORIES_FETCH_FAILED = 'syftacp/AGENCY_SHIFT_HISTORIES_FETCH_FAILED'
export const AGENCY_SHIFT_HISTORIES_FETCH_SUCCEEDED = 'syftacp/AGENCY_SHIFT_HISTORIES_FETCH_SUCCEEDED'

export default {
  AGENCY_SHIFT_HISTORIES_FETCH_FAILED,
  AGENCY_SHIFT_HISTORIES_FETCH_BEGIN,
  AGENCY_SHIFT_HISTORIES_FETCH_SUCCEEDED,
}
